import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { TABLET_WIDTH } from 'Styles/variables/sizes';

export const Header = styled.span`
  display: block;
  font-weight: 500;
  color: ${({ theme: { colors } }) => colors.blue_2};
  background: ${({ theme: { colors } }) => colors.blue_5};
  padding: 8px ${pxToRem(30)};
  margin: 0 ${pxToRem(-30)} 1rem;
`;

export const Input = styled.div`
  font-size: ${({ theme: { fontSizes } }) => pxToRem(fontSizes.xxs)};
  padding-bottom: ${pxToRem(10)};
  border-bottom: 1px solid
    ${({ theme: { colors }, hasError }) => (hasError ? colors.red_1 : colors.lightGrey)};
  display: flex;
  justify-content: space-between;
`;

export const TextAction = styled.div`
  font-size: ${({ theme: { fontSizes } }) => pxToRem(fontSizes.s)};
  color: ${({ theme: { colors } }) => colors.green_3};
  cursor: pointer;
  &:hover {
    color: ${({ theme: { colors } }) => colors.shadowGreen};
  }
`;

export const InputContainer = styled(FlexContainer)`
  position: relative;
  margin-bottom: ${pxToRem(24)};
  width: 100%;
  max-width: ${pxToRem(320)};
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  font-size: ${({ theme: { fontSizes } }) => pxToRem(fontSizes.s)};
  font-weight: bold;
  line-height: 1.43;
  padding: 0;
  cursor: pointer;
  svg {
    transform: rotate(180deg);
    margin-right: ${pxToRem(18)};
  }
  @media screen and (max-width: ${TABLET_WIDTH}) {
    display: flex;
    font-family: 'Arboria';
    margin-bottom: ${pxToRem(20)};
  }
`;
